import App from "./Altida.svelte";
const initConfig = {
    mainTitle: "Customize your Accora Altida",
    bookADemoHref: "https://accora.care/book-a-join-visit",
};
export const AltidaConfigurator = (targetId, config) => {
    const app = new App({
        target: document.getElementById(targetId),
        props: {
            config: Object.assign(Object.assign({}, initConfig), config),
        },
    });
    return app;
};
window.AltidaConfigurator = AltidaConfigurator;
export default AltidaConfigurator;
